import React from 'react'
import PicklistField from 'core/components/validatedForm/DropdownField'
import Dropdown from 'core/elements/dropdown'

export enum VmStorageOptions {
  volume = 'volume',
  ephemeral = 'ephemeral',
  ephemeral_and_volume = 'ephemeral_and_volume',
}

const options = [
  { label: 'Volume Only', value: VmStorageOptions.volume },
  { label: 'Ephemeral Only', value: VmStorageOptions.ephemeral },
  { label: 'Ephemeral and Volume', value: VmStorageOptions.ephemeral_and_volume },
]

interface VmStorageTypePicklistProps {
  id?: string
  label?: string
  required?: boolean
  value?: VmStorageOptions
  onChange?: (value: VmStorageOptions) => void
  tooltip?: string
}

export default function VmStorageTypePicklist({
  id = 'vmStorageType',
  label = 'VM Storage Type',
  required = false,
  value,
  onChange,
  tooltip,
}: VmStorageTypePicklistProps) {
  return (
    <PicklistField
      DropdownComponent={Dropdown}
      id={id}
      label={label}
      items={options}
      required={required}
      value={value}
      onChange={onChange}
      tooltip={tooltip}
    />
  )
}
